import {twMerge} from "tailwind-merge";

export default function TextInput({label, id, requiredLabel = false, classes = {} ,...otherProps}) {

    const {inputClasses = "", labelClasses = ""} = classes;

    return (
        <div className="w-full">
            <label className={twMerge("block mr-[1.125rem] mb-2.5 text-sm", labelClasses)} htmlFor={id}>
                {label}
                {requiredLabel ? <span className="text-pol-red align-super mr-0.5">*</span> : <span className="align-super" />}
            </label>
            <input id={id} className={twMerge("pol-simple-input bg-pol-light-purple-12 text-pol-dark border-pol-light-purple-11 hover:border-pol-blue focus:border-pol-blue", inputClasses)} {...otherProps}/>
        </div>
    )
}
